module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"language":"Sprache"},"en":{"language":"Language"},"it":{"language":""},"lt":{"language":"Kalba"},"pl":{"language":"Język"}}')
  delete Component.options._Ctor
}
